<template>
  <div>
    <div class="row">
      <div class="es-xs-12 u-padding-xsmall">
        <div class="o-card">
          <h3 class="u-margin-bottom-small u-color-primary">
            {{ $t("home.title") }}
          </h3>
          <p class="u-margin-bottom-small">
            {{ $t("home.description") }}
          </p>
        </div>
      </div>
      <div
        class="es-xs-12 es-sm-4 u-margin-bottom-small"
        v-for="item in menu"
        :key="item.name"
      >
        <component
          :is="item.path ? 'router-link' : 'div'"
          :to="item.path"
          class="o-card u-hover-select u-color-inherit u-display-block"
          @click="showDetail(item)"
        >
          <div class="u-text-align-center">
            <chip variant="primary">
              <i
                :class="`icofont-${item.icon} u-font-size-xlarge u-color-primary`"
              ></i>
            </chip>
            <h4 class="u-margin-top-small">{{ $t(item.name) }}</h4>
          </div>
        </component>
      </div>
    </div>
    <div class="u-text-align-center u-margin-top-small">
      <hr />
      <img src="@/assets/images/Logo.webp" alt="tms" width="125" />
      <img
        src="@/assets/images/Logo.png"
        alt="coolzone"
        width="100"
        class="u-margin-left-small"
      />
      <div class="u-margin-top-small">
        <p class="u-color-primary">
          <i class="icofont-copyright"></i>
          {{ new Date().getFullYear() }}
          <a href="https://www.tms.com.tr" target="_blank">TMS</a>
        </p>
      </div>
    </div>
    <Modal
      v-model="detail.show"
      hide-footer
      sm
      :title="$t(detail.item?.name)"
      @close="showDetail(null)"
    >
      <ul class="c-list" v-if="detail.item">
        <router-link
          v-for="sub in detail.item.sub"
          :key="sub.name"
          :to="sub.path"
        >
          <li class="c-list__item u-padding-small">
            <span>
              <i :class="`icofont-${sub.icon}`"></i>
              {{ $t(sub.name) }}
            </span>
          </li>
        </router-link>
      </ul>
    </Modal>
  </div>
</template>

<script>
import Menu from "@/components/Shared/Sidebar/menu.json";
import Chip from "../Base/Chip.vue";
import Modal from "../Base/Modal.vue";
export default {
  components: {
    Chip,
    Modal,
  },
  data() {
    return {
      menu: Menu,
      detail: {
        show: false,
        item: null,
      },
    };
  },
  computed: {
    getActiveUser() {
      return this.$store.getters.getActiveUser;
    },
    getAuthorizeList() {
      return this.$store.getters.getAuthorizeList;
    },
  },
  methods: {
    showDetail(item) {
      this.detail.item = item;
      this.detail.show = item ? true : false;
    },
    filterMenu() {
      // Admin için özel kontrol - sadece Admin rolüne ait menüleri göster
      if (this.getActiveUser.userInfo.role === "Admin") {
        return Menu.filter((item) => item.roles.includes("Admin")).map(
          (item) => ({
            ...item,
            validRole: true,
            validAuthorize: true,
            sub: item.sub.map((sub) => ({
              ...sub,
              validRoleSub: true,
              validAuthorizeSub: true,
            })),
          })
        );
      }

      // Diğer roller için menu kontrolü
      const menu = Menu.map((item) => {
        // Ana menü için role kontrolü
        const validRole = item.roles.includes(this.getActiveUser.userInfo.role);

        // Ana menü için authorize kontrolü
        const validAuthorize =
          item.authorize.length === 0 || // Eğer authorize array boşsa true
          !this.getAuthorizeList.some((userAuth) =>
            item.authorize.some(
              (menuAuth) =>
                menuAuth.method === userAuth.authorityInfo.method &&
                menuAuth.controller === userAuth.authorityInfo.controller &&
                menuAuth.action === userAuth.authorityInfo.action
            )
          );

        // Alt menüler için kontroller
        const subItems = item.sub.map((sub) => {
          const validRoleSub = sub.roles.includes(
            this.getActiveUser.userInfo.role
          );
          const validAuthorizeSub =
            sub.authorize.length === 0 || // Eğer authorize array boşsa true
            !this.getAuthorizeList.some((userAuth) =>
              sub.authorize.some(
                (menuAuth) =>
                  menuAuth.method === userAuth.authorityInfo.method &&
                  menuAuth.controller === userAuth.authorityInfo.controller &&
                  menuAuth.action === userAuth.authorityInfo.action
              )
            );
          return {
            ...sub,
            validRoleSub,
            validAuthorizeSub,
          };
        });

        return {
          ...item,
          validRole,
          validAuthorize,
          sub: subItems,
        };
      });

      // Filtreleme:
      // 1. Alt menüsü olmayan itemlar için: Direkt role ve authorize kontrolü
      // 2. Alt menüsü olan itemlar için:
      //    - Ana menünün role ve authorize kontrolü VE
      //    - En az bir alt menünün geçerli olması kontrolü
      return menu.filter((item) => {
        // Alt menüsü olmayan itemlar için kontrol
        if (item.sub.length === 0) {
          return item.validRole && item.validAuthorize;
        }

        // Alt menüsü olan itemlar için kontrol
        const hasValidSubItems = item.sub.some(
          (sub) => sub.validRoleSub && sub.validAuthorizeSub
        );

        return item.validRole && item.validAuthorize && hasValidSubItems;
      });
    },
  },
  mounted() {
    this.menu = this.filterMenu();
  },
};
</script>

<style></style>
